import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './item.vdt';
import { sizes } from '../../styles/utils';
import { types } from './styles';
import { useConfigContext } from '../config';
var typeDefs = {
  type: types,
  size: sizes
};
var defaults = function defaults() {
  return {
    type: 'primary',
    size: 'default'
  };
};
export var TimelineItem = /*#__PURE__*/function (_Component) {
  _inheritsLoose(TimelineItem, _Component);
  function TimelineItem() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.config = useConfigContext();
    return _this;
  }
  return TimelineItem;
}(Component);
TimelineItem.template = template;
TimelineItem.typeDefs = typeDefs;
TimelineItem.defaults = defaults;